import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newData: 1,
    currentIndex: 0,
    count: 0,
  },
  mutations: {
    mutationsAddCount(state, n = 0) {
      return (state.count += n)
    },
    mutationsReduceCount(state, n = 0) {
      state.count -= n;
      if (state.count < 0) {
        alert("不能再少了哦")
        return state.count += n
      } else {
        return state.count
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
